export default {"wholesaleBoxWrapper":"IEsYG","text":"Ahby3","icon":"Qab5t"};